// FREO: `color` prop is accepted but not forwarded to ChakraSpinner; default hex is a dead value kept for API stability.
import { Flex } from "@chakra-ui/react/flex";
import { Spinner as ChakraSpinner } from "@chakra-ui/react/spinner";
import React from "react";

interface SpinnerProps {
  color?: string;
  size?: number;
}

const Spinner = ({ color = "#000", size = 60 }: SpinnerProps) => (
  <Flex
    data-testid="spinner"
    alignItems="center"
    justifyContent="center"
    margin="auto"
    height="100%"
  >
    <ChakraSpinner />
  </Flex>
);

export default Spinner;
